import { KeyboardEvent, ReactNode, RefObject } from 'react'

export enum SelectSizeEnum {
  small = 'small',
  medium = 'medium',
  large = 'large',
}

export interface SelectOptionProps {
  value: string
  label: string
}

export enum SelectVariantEnum {
  primary = 'primary',
  info = 'info',
  danger = 'danger',
}

export interface SelectProps {
  id?: string
  className?: string
  disabled?: boolean
  size?: keyof typeof SelectSizeEnum
  onChange?: (value: string) => void
  value?: string
  placeholder?: string
  iconLeft?: ReactNode
  iconRight?: ReactNode
  options: SelectOptionProps[]
  error?: string
  ref?: RefObject<HTMLSelectElement>
  onKeyDown?: (event: KeyboardEvent<HTMLSelectElement>) => void
  variant?: keyof typeof SelectVariantEnum
  allowEmpty?: boolean
}
